import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PortalUser } from '../../../interfaces/PortalUser';
import { SharedLoginSingletonService } from '@huge-monorepo/shared/services';
import { ICustomerLoginService, IHIPLoginService } from '@huge-monorepo/shared/interfaces';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  loginService = this.sharedLoginService.getService();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private sharedLoginService: SharedLoginSingletonService<IHIPLoginService | ICustomerLoginService>,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  emailControl = new UntypedFormControl('', [Validators.required, Validators.email]);

  ionicFormGroup = new UntypedFormGroup({
    emailControl: this.emailControl,
  });

  validations_form = this.formBuilder.group({
    emailControl: this.emailControl,
  });

  validation_messages = {
    emailControl: [
      { type: 'required', message: 'Email is required.' },
      { type: 'email', message: 'Enter valid email.' },
    ],
  };

  ngOnInit() {
    const email = this.route.snapshot.paramMap.get('email');
    this.emailControl.setValue(email);
  }

  cancel() {
    this.router.navigate(['/']);
  }

  getPasswordClicked() {
    if (this.emailControl.value !== '' && this.emailControl.errors == null) {
      const user: PortalUser = {
        ID: null,
        Name: '',
        Surname: '',
        Email: this.emailControl.value,
        GUID: '',
        OTPEnabled: false,
        IsActive: '',
        UserRoles: '',
        Password: '',
      };

      this.loginService.ForgotPasswordRequest(user).subscribe({
        error: (err) => {
        },
        complete: () => {
        },
      });
    } else {
      this.emailControl.markAsTouched();
    }
  }
}
